{
    "actions": {
        "page": {
            "add_contract_access": "Nouveau compte marchand"
        },
        "row": {
            "activate": "Réactiver",
            "deactivate": "Désactiver",
            "update_label": "Modifier le libellé"
        }
    },
    "filter": {
        "placeholder": {
            "email": "Filtrer par email",
            "label": "Filtrer par libellé"
        }
    },
    "keys": {
        "status": "Statut",
        "email": "Email",
        "label": "Libellé",
        "created_at": "Créé le",
        "updated_at": "MAJ le"
    },
    "modal": {
        "create_merchant_account": {
            "title": "Création de compte marchand",
            "steps": {
                "form": "Étape {{step}} sur {{maxStep}} : Saisie du mail et du libellé",
                "contract_selection": "Étape {{step}} sur {{maxStep}} : Sélection des contrats",
                "contract_edition": "Étape {{step}} sur {{maxStep}} : Edition des rangs et du libellé marchand",
                "confirmation": "Étape {{step}} sur {{maxStep}} : Confirmation"
            },
            "labels": {
                "email": "Email",
                "label": "Libellé",
                "ranks": {
                    "all": "Tous les rangs",
                    "range": "Plage de rangs",
                    "simple": "Saisie de rangs",
                    "from": "de",
                    "to": "à"
                }
            },
            "placeholders": {
                "email": "Entrer une adresse ici...",
                "label": "100 caractères max.",
                "ranks": {
                    "range": "3 chiffes (ex: 001)",
                    "simple": "(ex: 001, 010, 099)"
                }
            },
            "texts": {
                "contract": "Contrat n°{{contractNumber}}",
                "bank_code": "Code banque {{bankCode}}",
                "confirmation": "Confirmez la création du compte marchand \"{{label}}\" associé aux {{contracts}} contrats suivants :"
            },
            "success": "Compte marchand créé avec succès !",
            "error": "Une erreur est survenue lors de la création du compte marchand"
        },
        "add_contracts": {
            "title": "Ajout de contrats dans le compte marchand",
            "steps": {
                "contract_selection": "Étape {{step}} sur {{maxStep}} : Sélection des contrats",
                "contract_edition": "Étape {{step}} sur {{maxStep}} : Edition des rangs et du libellé marchand",
                "confirmation": "Étape {{step}} sur {{maxStep}} : Confirmation"
            },
            "labels": {
                "ranks": {
                    "all": "Tous les rangs",
                    "range": "Plage de rangs",
                    "simple": "Saisie de rangs",
                    "from": "de",
                    "to": "à"
                }
            },
            "placeholders": {
                "ranks": {
                    "range": "3 chiffes (ex: 001)",
                    "simple": "(ex: 001, 010, 099)"
                }
            },
            "texts": {
                "contract": "Contrat n°{{contractNumber}}",
                "bank_code": "Code banque {{bankCode}}",
                "confirmation": "Confirmez l'ajout des contrats suivants dans le compte marchand \"{{label}}\" :"
            },
            "success": "Contrats ajoutés avec succès dans le compte marchand !",
            "error": "Une erreur est survenue lors de l'ajout des contrats dans le compte marchand"
        },
        "delete_multiple_contracts": {
            "title": "Suppression multiple contrats",
            "steps": {
                "contracts_selection": "Étape {{step}} sur {{maxStep}} : Sélection des contrats",
                "confirm": "Étape {{step}} sur {{maxStep}} : Confirmation de suppression multiple"
            },
            "confirmation": {
                "text_1": "Cette opération va supprimer {{number}} contrat du compte marchand \"{{label}}\". Les informations de paiements de ce contrat ne seront pas supprimées et restent accessibles. Cette action entrainera la suppression de ce contrat associé à des groupes.",
                "text_2": "Veuillez confirmer la demande de suppression pour ce contrat"
            }
        },
        "import": {
            "explanations": {
                "header": "Il est possible d'ajouter des comptes marchand par fichier CSV. Le fichier à importer doit contenir les 7 colonnes suivantes :",
                "label_account": "label_account : libellé du compte marchand",
                "mail": "mail : adresses éléctroniques des utilisateurs marchands qui auront accès à ce compte (maximum 5 par compte) séparés par des virgules",
                "contrat": "contrat : numéro de contrat à 7 chiffres",
                "application": "application : identifie l'application du contrat",
                "bank_code": "bank_code : code de la banque acquéreur",
                "rank": "rank : numéro de rang sur 3 chiffres. Il peut comporter une ou plusieurs valeurs séparées par des virgules (exemple \"001,002,007\"), définir une plage (exemple 001-010) ou être vide pour autoriser tous les rangs",
                "contract_label": "contract_label : libellé pour identifier chacun des contrats renseignés",
                "multiple_contracts": "Il est possible d'ajouter plusieurs contrats pour un même compte marchand, pour cela les champs contract, application, code banque et rang doivent être renseignés pour chacun des contrats à ajouter.",
                "warning": "Attention : seul un contrat existant sur la passerelle pourra être ajouté à un compte marchand. Si un contrant n'est pas connu de notre passerelle, il ne sera pas ajouté."
            },
            "confirmation": "Cette opération va ajouter {{numberOfAccounts}} comptes marchand. Souhaitez-vous continuer ?",
            "success": "Comptes marchand créés avec succès !",
            "error": {
                "invalid_file": "Ce fichier n'est pas compatible (.csv uniquement)",
                "error": "Attention ! Nous avons détecté les erreurs suivantes dans votre fichier CSV : ",
                "alreadyExistingMerchantAccount": "- Déjà créé",
                "emailIsInvalid": "- Email",
                "contractIsInvalid": "- Contrat",
                "bankCodeIsInvalid": "- Code banque",
                "applicationIsInvalid": "- Application",
                "rankIsInvalid": "- Rang",
                "labelAccountIsInvalid": "- Libellé Compte marchand",
                "contractLabelIsInvalid": "- Libellé contrat",
                "error_2": "Les comptes listés ci-dessus n'ont pas pu être créé. Vous pouvez corriger ces erreurs dans un nouveau fichier CSV et retenter l'opération ou passer par le portail.",
                "UNEXPECTED_ERROR": "Une erreur est survenue, veuillez réessayer ultérieurement.",
                "no_token": "Attention ! Aucun compte marchand n'a pu être créé. Ci-dessous la liste des erreurs qui ont été identifiées : ",
                "get_example_file": "N'hésitez pas à télécharger notre modèle de fichier pour faciliter le remplissage.",
                "BAD_FORMAT": "Le fichier CSV est mal formé.",
                "TOO_MANY_RESOURCES": "L’import de contrats par fichier CSV est limité à 10 000 contrats",
                "INTERNAL_SERVER_ERROR": "Une erreur inconnue est survenue"
            },
            "send_reset_password": {
                "text_1": "Félicitations ! Vos comptes marchand ont été créés avec succès.",
                "text_2": "Il reste une dernière étape qui concerne l'envoi des mails de personnalisation des mots de passe pour les utilisateurs des nouveaux comptes marchand que vous venez de créer.",
                "text_3": "Attention ! Si vous ne cliquez pas sur le bouton ci-dessus, vous devrez obligatoirement gérer l'envoi des mails de personnalisation de mot de passe pour les utilisateurs des nouveaux comptes marchand depuis votre portail.",
                "button": "Confirmer l'envoi des mails de personnalisation des mots de passe",
                "success": "Votre demande de création de comptes marchand a été effectuée avec succès",
                "error": "Une erreur est survenue"
            }
        },
        "update_merchant_label": {
            "title": "Modifier le libellé du compte marchand",
            "success": "Compte marchand mis à jour avec succès !",
            "error": "Une erreur est survenue lors de la mise à jour",
            "label": "Libelle *",
            "placeholder": "Saisir le libelle"
        }
    },
    "status": {
        "ACTIVE": "Activé",
        "INACTIVE": "Désactivé"
    },
    "toast": {
        "success": {
            "activate": "Réactivation du compte marchand réussie",
            "deactivate": "Désactivation du compte marchand réussie",
            "delete_multiple_contracts": "Contrats supprimés avec succès !"
        },
        "error": {
            "activate": "Réactivation du compte marchand interrompue",
            "deactivate": "Désactivation du compte marchand interrompue",
            "delete_multiple_contracts": "Nous avons rencontré une erreur lors de suppression multiple. Merci de réessayer."
        }
    }
}